import * as Sentry from "@sentry/react";
import "ext/js";
import { Consts } from "./vars";
/** Returns correctly pluralized term for given count */
export function pluralize(count, term, useNo = false) {
    if (count === 0) {
        return `${useNo ? "No" : "0"} ${term}s`;
    }
    if (count === 1) {
        return `1 ${term}`;
    }
    return `${count} ${term}s`;
}
export function crumb(category, message) {
    Sentry.addBreadcrumb({ category, message });
}
/** Compares two floats to be "equal" enough */
export function equals(a, b) {
    return Math.abs(a - b) < Consts.epsilon;
}
export function getUrlParameter(paramName) {
    let pageUrl = decodeURIComponent(window.location.search.substring(1));
    let params = pageUrl.split('&');
    for (var i = 0; i < params.length; i++) {
        let param = params[i].split('=');
        if (param[0] === paramName) {
            return params[1] === undefined ? true : params[1];
        }
    }
}
/** Returns true if the current browser is IE or Edge. */
export function isIEOrEdge() {
    let uaString = window.navigator.userAgent;
    var match = /\b(MSIE |Trident.*?rv:|Edge\/)(\d+)/.exec(uaString);
    if (match)
        return true;
    return false;
}
export const isIOS = window.navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
export function isSafari() {
    var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    // var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    return isSafari;
}
/** Execute a block of code that may open a window. Use opener to open the window. */
export function opensWindow(fn) {
    let opener;
    if (isSafari()) {
        // On Safari, we need to open the window immediately, otherwise it gets
        // blocked and it's hard to open it.
        // https://stackoverflow.com/questions/20696041/window-openurl-blank-not-working-on-imac-safari
        const windowReferenceForSafari = window.open();
        if (windowReferenceForSafari != null) {
            windowReferenceForSafari.document.write("<html><body><center style='margin-top:5em'>Retrieving information, please wait...</center></body></html>");
            opener = (url) => {
                windowReferenceForSafari.location.href = url;
            };
        }
        else {
            opener = (url) => window.open(url);
        }
    }
    else {
        opener = (url) => window.open(url);
    }
    fn(opener);
}
/** IE cannot download images directly so have use this method. */
export function saveBlobHack(el, mime) {
    // Based on:
    // https://github.com/mholt/PapaParse/issues/175
    // https://stackoverflow.com/questions/69552023/after-update-typescript-3-7-2-to-latest-typescript-4-4-4-error-ts2339
    if (window.navigator.msSaveOrOpenBlob !== undefined) {
        let data = $(el).attr("href") || "";
        // Remove the data URI header. Convert to binary.
        let rawData = atob(data.replace(`data:${mime};base64,`, ""));
        var rawLength = rawData.length;
        var dataArray = new Uint8Array(rawLength);
        for (var i = 0; i < rawLength; i++) {
            dataArray[i] = rawData.charCodeAt(i);
        }
        let blob = new Blob([dataArray], { type: mime });
        // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
        let filename = (() => {
            switch (mime) {
                case "image/svg":
                    return "chemix.svg";
                case "image/png":
                default:
                    return "chemix.png";
            }
        })();
        window.navigator.msSaveBlob(blob, filename);
    }
}
/** Use after a switch to make sure all cases have been handled. */
export function assertUnreachable(e) {
    throw new Error("Non-exhaustive switch");
}
export class Lazy {
    constructor(initializer) {
        this.instance = null;
        this.initializer = initializer;
    }
    get value() {
        if (this.instance == null) {
            this.instance = this.initializer();
        }
        return this.instance;
    }
}
/**
 * https://github.com/moroshko/shallow-equal/blob/master/src/objects.js
 */
export default function shallowEqualObjects(objA, objB) {
    if (objA === objB) {
        return true;
    }
    if (!objA || !objB) {
        return false;
    }
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) {
        return false;
    }
    for (var i = 0; i < len; i++) {
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
            return false;
        }
    }
    return true;
}
